"use client";

import PageBuilder from "@/components/pageBuilder/PageBuilder";

export default function PageBuilderClient({
  config,
  locale,
  currency,
  additionalParams = {},
  translationData = {},
  hideEmptySections = false,
}) {
  // Component registry ve item prop mapping'i config'den al
  const componentRegistry = config.componentRegistry || {};
  const itemPropMapping = config.itemPropMapping || {};

  // ISG quality gate — warm fonksiyonu bu meta tag'den beklenen section sayısını okur
  const expectedSections = config?.sections?.length || 0;

  return (
    <>
      {expectedSections > 0 && (
        <span data-isg-expected-sections={String(expectedSections)} hidden />
      )}
      <PageBuilder
        config={config}
        locale={locale}
        currency={currency}
        additionalParams={additionalParams}
        componentRegistry={componentRegistry}
        itemPropMapping={itemPropMapping}
        translationData={translationData}
        hideEmptySections={hideEmptySections}
      />
    </>
  );
}
